import { createReducer } from '@reduxjs/toolkit';
import {
  DELETE_INTERCOM_USER,
  DELETE_INTERCOM_USER_FROM_CACHE,
  GET_GRATA_INTERCOM_USER,
  GET_INTERCOM_UNIT_PINS,
  SEARCH_INTERCOM_USERS,
  UPDATE_INTERCOM_USER,
  UPDATE_INTERCOM_USERS_CACHE
} from '../constants';
import { requestFail, requestPending, requestSuccess } from '../../utils/status';

// TODO: Caching
const initialState = {
  getIntercomUnitPinsStatus: '',
  getIntercomUnitPinsError: '',
  getIntercomUnitPinsData: [],

  updateIntercomUserStatus: '',
  updateIntercomUserError: '',

  getGrataUserStatus: '',
  getGrataUserError: '',
  getGrataUserData: undefined,

  deleteIntercomUserStatus: '',
  deleteIntercomUserError: '',

  searchIntercomUsersStatus: '',
  searchIntercomUsersError: '',
  searchIntercomUsersData: []
};

export default createReducer(initialState, {
  // Intercom Unit Pins

  [requestSuccess(GET_INTERCOM_UNIT_PINS)]: (state, { payload }) => ({
    ...state,
    getIntercomUnitPinsData: payload,
    getIntercomUnitPinsStatus: requestSuccess(GET_INTERCOM_UNIT_PINS),
    getIntercomUnitPinsError: null
  }),

  [requestPending(GET_INTERCOM_UNIT_PINS)]: (state) => ({
    ...state,
    getIntercomUnitPinsStatus: requestPending(GET_INTERCOM_UNIT_PINS)
  }),

  [requestFail(GET_INTERCOM_UNIT_PINS)]: (state, { payload }) => ({
    ...state,
    getIntercomUnitPinsData: undefined,
    getIntercomUnitPinsStatus: requestFail(GET_INTERCOM_UNIT_PINS),
    getIntercomUnitPinsError: payload
  }),

  // Intercom User Update

  [requestSuccess(UPDATE_INTERCOM_USER)]: (state, { payload }) => ({
    ...state,
    updateIntercomUserStatus: requestSuccess(UPDATE_INTERCOM_USER),
    updateIntercomUserError: null
  }),

  [requestPending(UPDATE_INTERCOM_USER)]: (state) => ({
    ...state,
    updateIntercomUserStatus: requestPending(UPDATE_INTERCOM_USER),
    updateIntercomUserError: null
  }),

  [requestFail(UPDATE_INTERCOM_USER)]: (state, { payload }) => ({
    ...state,
    updateIntercomUserStatus: requestFail(UPDATE_INTERCOM_USER),
    updateIntercomUserError: payload
  }),

  // Intercom User Search

  [requestSuccess(SEARCH_INTERCOM_USERS)]: (state, { payload }) => ({
    ...state,
    searchIntercomUsersData: payload,
    searchIntercomUsersStatus: requestSuccess(SEARCH_INTERCOM_USERS),
    searchIntercomUsersError: null
  }),

  [requestPending(SEARCH_INTERCOM_USERS)]: (state) => ({
    ...state,
    searchIntercomUsersStatus: requestPending(SEARCH_INTERCOM_USERS)
  }),

  [requestFail(SEARCH_INTERCOM_USERS)]: (state, { payload }) => ({
    ...state,
    searchIntercomUsersData: [],
    searchIntercomUsersStatus: requestFail(SEARCH_INTERCOM_USERS),
    searchIntercomUsersError: payload
  }),

  // Intercom User Delete

  [requestSuccess(DELETE_INTERCOM_USER)]: (state) => ({
    ...state,
    deleteIntercomUserStatus: requestSuccess(DELETE_INTERCOM_USER),
    deleteIntercomUserError: null
  }),

  [requestPending(DELETE_INTERCOM_USER)]: (state) => ({
    ...state,
    deleteIntercomUserStatus: requestPending(DELETE_INTERCOM_USER),
    deleteIntercomUserError: null
  }),

  [requestFail(DELETE_INTERCOM_USER)]: (state, { payload }) => ({
    ...state,
    deleteIntercomUserStatus: requestFail(DELETE_INTERCOM_USER),
    deleteIntercomUserError: payload
  }),

  [UPDATE_INTERCOM_USERS_CACHE]: (state, { payload }) => {
    return {
      ...state,
      searchIntercomUsersData: {
        ...state.searchIntercomUsersData,
        data: state.searchIntercomUsersData.data.map((user) => {
          if (user.id === payload.id) {
            return {
              ...user,
              ...payload
            };
          }
          return user;
        })
      }
    };
  },

  [DELETE_INTERCOM_USER_FROM_CACHE]: (state, { payload }) => ({
    ...state,
    searchIntercomUsersData: {
      ...state.searchIntercomUsersData,
      data: state.searchIntercomUsersData.data.filter((user) => user.id !== payload.id)
    }
  }),

  // Get Grata User

  [requestSuccess(GET_GRATA_INTERCOM_USER)]: (state, { payload }) => ({
    ...state,
    getGrataUserData: payload,
    getGrataUserStatus: requestSuccess(GET_GRATA_INTERCOM_USER),
    getGrataUserError: null
  }),

  [requestPending(GET_GRATA_INTERCOM_USER)]: (state) => ({
    ...state,
    getGrataUserStatus: requestPending(GET_GRATA_INTERCOM_USER)
  }),

  [requestFail(GET_GRATA_INTERCOM_USER)]: (state, { payload }) => ({
    ...state,
    getGrataUserData: undefined,
    getGrataUserStatus: requestFail(GET_GRATA_INTERCOM_USER),
    getGrataUserError: payload
  })
});
